var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-detail"},[_c('div',[(_vm.detailInfo)?_c('desc-item',{attrs:{"url":_vm.detailInfo.intro_url,"unqie":_vm.detail}}):_vm._e()],1),_vm._v(" "),(_vm.isshowBacktop)?_c('v-back-top',{attrs:{"target":_vm.target}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58938a8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/product-detail/child/ProductDesc.vue
// module id = null
// module chunks = 